import { render, staticRenderFns } from "./clockInRecord.vue?vue&type=template&id=637d5a1a&scoped=true&"
import script from "./clockInRecord.vue?vue&type=script&lang=js&"
export * from "./clockInRecord.vue?vue&type=script&lang=js&"
import style0 from "./clockInRecord.vue?vue&type=style&index=0&id=637d5a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637d5a1a",
  null
  
)

export default component.exports